<app-modal
  *ngIf="modalVars['auth']"
  class="lm-modal"
  id="auth"
  data-testid="qa_auth-modal"
  (closeModal)="clearAuthFormSettings()"
>
  <ng-container *ngIf="!isRegistrationSent; else thankYou">
    <div class="auth">
      <div class="auth__proceed">
        <div class="auth__header">
          <span
            class="auth__header-btn"
            id="qa_auth-login-tab"
            [ngClass]="{ 'is-active': authType === authTypeEnum.logIn, 'auth__header-btn--wide': isOnlyLogin }"
            (click)="toggleForm(authTypeEnum.logIn)"
            >{{ 'auth-login' | translate }}</span
          >
          <span
            *ngIf="!isOnlyLogin"
            class="auth__header-btn"
            id="qa_auth-signup-tab"
            [ngClass]="{ 'is-active': authType === authTypeEnum.signUp }"
            (click)="toggleForm(authTypeEnum.signUp)"
            >{{ 'auth-signup' | translate }}</span
          >
        </div>
        <div class="lm-modal__body auth__body" [ngSwitch]="authType">
          <div
            *ngIf="authType === authTypeEnum.logIn && shouldDisplayAccountCongratsMessage"
            class="auth__message-block"
          >
            <p class="lm-modal__text message-block__success">
              {{ 'account.congrats-text' | translate }}
            </p>
          </div>
          <h2 *ngIf="shouldShowNewMembershipTitle" class="membership__title" data-testid="qa-auth-modal-signup-title">
            {{ 'auth.membership-title' | translate }}
          </h2>

          <form class="auth__form" data-testid="qa-auth-form" [formGroup]="authForm" (ngSubmit)="sendAuth()">
            <!--
            This checkbox is used to hide a checkbox from bots
            More details about the solution in https://stackoverflow.com/questions/36227376/better-honeypot-implementation-form-anti-spam-->
            <input
              type="checkbox"
              id="honey-checkbox"
              value="1"
              class="honey-checkbox"
              tabindex="-1"
              autocomplete="off"
              formControlName="honeyCheckbox"
            />
            <p
              *ngIf="accountError"
              class="site__form-error site__form-main-error"
              data-testid="qa-auth-form-error"
              [innerHTML]="accountError | translate"
            ></p>
            <div class="auth__fields">
              <div sparkFormField class="site__field w-full" data-testid="qa-auth-email-field">
                <input
                  sparkInput
                  data-hj-suppress
                  type="email"
                  id="email"
                  class="w-full"
                  formControlName="email"
                  autocomplete="off"
                  [status]="isAuthFormSubmitted && authForm.controls.email.errors ? 'error' : 'default'"
                />
                <label sparkInputLabel for="email">
                  {{ 'email' | translate }}
                </label>
                <!-- ngClass is used to override class "hidden" that default class if form field is pristine. After submit all fields are pristine that is preventing an error to be displayed. -->
                <span
                  sparkFormError
                  validator="required"
                  [ngClass]="{ 'data-[validator=fail]:flex': isAuthFormSubmitted }"
                >
                  {{ 'login.enter-valid-email' | translate }}
                </span>
                <span sparkFormError validator="pattern">
                  {{ 'login.enter-valid-email' | translate }}
                </span>
              </div>
              <div sparkFormField class="site__field w-full" data-testid="qa-auth-password-field">
                <input
                  sparkInput
                  data-hj-suppress
                  type="password"
                  class="w-full"
                  id="password"
                  formControlName="password"
                  autocomplete="off"
                  withVisibilityButton
                  [status]="isAuthFormSubmitted && authForm.controls.password.errors ? 'error' : 'default'"
                />
                <label sparkInputLabel for="password">
                  {{ 'login.password' | translate }}
                </label>
                <ng-container
                  *ngIf="
                    (isAuthFormSubmitted && authForm.controls.password.errors) ||
                    (authType === authTypeEnum.signUp && signUpPasswordScore >= 0 && authForm.controls.password.value)
                  "
                >
                  <div
                    sparkFormError
                    validator="required"
                    [ngClass]="{
                      'data-[validator=fail]:flex': isAuthFormSubmitted
                    }"
                  >
                    <span>{{ 'login.enter-password' | translate }}</span>
                  </div>
                  <span sparkFormError validator="minlength">
                    {{ 'login.choose-stronger-password' | translate }}
                  </span>
                  <span sparkFormError validator="weak">
                    {{ 'login.choose-stronger-password' | translate }}
                  </span>
                </ng-container>
                <div
                  *ngIf="
                    authType === authTypeEnum.signUp && signUpPasswordScore >= 0 && authForm.controls.password.value
                  "
                  class="progress-bar progress-bar--{{ signUpPasswordScore }}"
                >
                  {{ 'login.' + passwordStrength[signUpPasswordScore] | translate }}
                </div>
              </div>
            </div>
            <ng-container *ngIf="authType === authTypeEnum.signUp">
              <div sparkFormField data-testid="qa-auth-agree-to-limehome-terms-checkbox">
                <span
                  id="agree"
                  required
                  sparkCheckbox
                  [checked]="agreeControl?.value"
                  [hasError]="isAuthFormSubmitted && authForm.controls.agree.errors"
                  (checkedChange)="agreeControl?.setValue($event)"
                ></span>
                <label sparkLabel size="small" data-testid="qa-auth-agree-to-limehome-terms" for="agree">
                  <p
                    [innerHTML]="
                      'login.agree-to-limehome-terms-label' | translate: { url: externalLinks.privacyPolicy | localize }
                    "
                  ></p>
                  <span sparkFormError validator="required" withIcon="false">{{
                    'login.agree-to-limehome-terms-error' | translate
                  }}</span>
                </label>
              </div>

              <div sparkFormField class="mt-4" data-testid="qa-auth-newsletter-subscribe-label">
                <span
                  data-testid="qa-auth-newsletter-subscribe-checkbox"
                  id="newsletter"
                  sparkCheckbox
                  [checked]="newsletterControl?.value"
                  (checkedChange)="newsletterControl?.setValue($event)"
                ></span>
                <label for="newsletter" sparkLabel size="small">{{ 'checkout-account-newsletter' | translate }}</label>
              </div>
            </ng-container>

            <button
              type="submit"
              sparkButton
              size="large"
              class="w-full mt-[23px] !normal-case"
              data-testid="qa-auth-submit-btn"
              [disabled]="isFetching"
              [attr.id]="authTypeEnum.logIn ? 'qa_auth-login-btn' : 'qa_auth-signup-btn'"
            >
              <span *ngIf="!isFetching">{{
                (authType === authTypeEnum.logIn ? 'auth-login' : 'auth-signup') | translate
              }}</span>
              <app-loading-indicator *ngIf="isFetching" />
            </button>
            <div class="auth__forgot-pass">
              <a
                href="#"
                id="qa_auth-forgot-password"
                data-testid="qa-auth-forgot-password-link"
                (click)="showForgotPasswordModal($event)"
                >{{ 'login.forgot-password' | translate }}</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #thankYou>
    <div class="lm-modal__body">
      <h2 class="lm-modal__title">{{ 'login.thank-you-title' | translate }}</h2>
      <p class="lm-modal__text">
        {{ (isAccountAlreadyActive ? 'login.account-created' : 'login.thank-you-text') | translate }}
      </p>
      <button sparkButton class="lm-modal__btn w-full" type="button" (click)="closeAuthModal()">
        {{ (isCheckoutPage ? 'login.finish-booking' : 'checkout-continue') | translate }}
      </button>
    </div>
  </ng-template>
</app-modal>

<app-modal
  *ngIf="modalVars['created-account']"
  class="lm-modal"
  id="created-account"
  (closeModal)="closeSuccessfulModal(createdAccountCongratsModalId, false)"
>
  <div class="lm-modal__body">
    <h2 class="lm-modal__title">{{ 'account.congrats-title' | translate }}</h2>
    <p class="lm-modal__text">{{ 'account.congrats-text' | translate }}</p>
    <button
      sparkButton
      class="lm-modal__btn w-full"
      (click)="closeSuccessfulModal(createdAccountCongratsModalId, false)"
    >
      {{ 'alert.modal-button' | translate }}
    </button>
  </div>
</app-modal>

<app-modal
  *ngIf="modalVars['created-newsletter-only-account']"
  class="lm-modal"
  id="created-newsletter-only-account"
  (closeModal)="closeSuccessfulModal(createdAccountNewsletterOnlyCongratsModalId, true)"
>
  <div class="lm-modal__body">
    <h2 class="lm-modal__title">{{ 'account-newsletter-only.congrats-title' | translate }}</h2>
    <p class="lm-modal__text">{{ 'account-newsletter-only.congrats-text' | translate }}</p>
    <button
      sparkButton
      class="lm-modal__btn w-full"
      (click)="closeSuccessfulModal(createdAccountNewsletterOnlyCongratsModalId, true)"
    >
      {{ 'alert.modal-button' | translate }}
    </button>
  </div>
</app-modal>

<app-modal *ngIf="modalVars['error-modal']" class="lm-modal" id="error-modal" (closeModal)="goToHome()">
  <div class="lm-modal__body">
    <h2 class="lm-modal__title">{{ 'account.error-title' | translate }}</h2>
    <p class="lm-modal__text" [innerHTML]="accountError | translate"></p>
    <button sparkButton class="w-full" type="button" (click)="closeActivationErrorModal(errorModalId)">
      {{ 'alert.modal-button' | translate }}
    </button>
  </div>
</app-modal>

<app-modal
  *ngIf="modalVars['forgot-password']"
  class="lm-modal"
  id="forgot-password"
  data-testid="qa-forgot-password"
  (closeModal)="clearForgotPasswordForm()"
>
  <div class="lm-modal__body">
    <ng-container *ngIf="!isForgotPasswordRequestSuccess && forgotPasswordForm">
      <h2 class="lm-modal__title">{{ 'login.enter-email' | translate }}</h2>
      <form class="lm-modal__forgot" [formGroup]="forgotPasswordForm" (ngSubmit)="sendForgotPassword()">
        <p
          *ngIf="accountError"
          class="site__form-error site__form-main-error"
          data-testid="qa-forgot-password-error"
          [innerHTML]="accountError | translate"
        ></p>
        <div class="lm-modal__forgot-field">
          <label class="site__label" for="email-forgot">
            {{ 'email' | translate }} <span class="site__field-asterisk">*</span>
          </label>
          <input
            data-hj-suppress
            type="email"
            class="nice-input"
            required
            id="email-forgot"
            formControlName="email"
            autocomplete="off"
            tabindex="201"
            [ngClass]="{ error: isForgotPasswordSent && forgotPasswordForm.controls.email.errors }"
          />
          <p
            *ngIf="isForgotPasswordSent && forgotPasswordForm.controls.email.errors"
            class="site__form-error site__form-error--tc site__form-main-error"
          >
            {{ 'login.enter-valid-email' | translate }}
          </p>
        </div>
        <button
          type="submit"
          id="qa-auth-forgot-password-btn"
          data-testid="qa-auth-forgot-password-btn"
          sparkButton
          size="large"
          class="w-full mt-[23px]"
        >
          <span *ngIf="!isFetching">{{ 'submit' | translate }}</span>
          <app-loading-indicator *ngIf="isFetching" />
        </button>
      </form>
    </ng-container>
    <ng-container *ngIf="isForgotPasswordRequestSuccess">
      <p class="lm-modal__text">{{ 'login.reset-password-message' | translate }}</p>
      <button
        data-testid="qa_forgot-password-ok-btn"
        sparkButton
        size="large"
        class="w-full mt-[23px]"
        (click)="closeForgotPasswordModal(forgotPasswordModalId)"
      >
        {{ 'alert.modal-button' | translate }}
      </button>
    </ng-container>
  </div>
</app-modal>

<app-modal
  *ngIf="modalVars['reset-password']"
  class="lm-modal"
  id="reset-password"
  data-testid="qa-reset-password"
  (closeModal)="closeResetPasswordModal(resetPasswordModalId)"
>
  <div class="lm-modal__body" [ngClass]="{ 'lm-modal__body--no-head': isResetPasswordRequestSuccess }">
    <ng-container *ngIf="!isResetPasswordRequestSuccess && resetPasswordForm">
      <h2 class="lm-modal__title">{{ 'login.reset-password-title' | translate }}</h2>
      <form class="lm-modal__reset" [formGroup]="resetPasswordForm" (ngSubmit)="sendResetPassword()">
        <p
          *ngIf="accountError"
          class="site__form-error site__form-main-error"
          data-testid="qa-reset-password-error"
          [innerHTML]="accountError | translate"
        ></p>
        <div class="lm-modal__reset-field">
          <label class="site__label" for="new-password">
            {{ 'profile.new-password' | translate }} <span class="site__field-asterisk">*</span>
          </label>
          <div class="site__field-inner">
            <input
              data-hj-suppress
              type="password"
              class="nice-input"
              required
              id="new-password"
              formControlName="newPassword"
              appTogglePassword
              autocomplete="off"
              tabindex="201"
              [ngClass]="{ error: isResetPasswordSent && resetPasswordForm.controls.newPassword.errors }"
            />
          </div>
          <ng-container
            *ngIf="
              (isResetPasswordSent && resetPasswordForm.controls.newPassword.errors) ||
              (signUpPasswordScore >= 0 && resetPasswordForm.controls.newPassword.value)
            "
          >
            <p
              *ngIf="
                resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.required
              "
              class="site__form-error site__form-error--tc site__form-main-error"
            >
              <span>{{ 'login.enter-password' | translate }}</span>
            </p>
            <p
              *ngIf="
                resetPasswordForm.controls.newPassword.errors &&
                (resetPasswordForm.controls.newPassword.errors.weak ||
                  resetPasswordForm.controls.newPassword.errors.minlength)
              "
              class="site__form-error site__form-error--tc site__form-main-error"
            >
              <span [innerHTML]="'login.choose-stronger-password' | translate"></span>
            </p>
          </ng-container>
          <div
            *ngIf="signUpPasswordScore >= 0 && resetPasswordForm.controls.newPassword.value"
            class="progress-bar progress-bar--{{ signUpPasswordScore }}"
          >
            {{ 'login.' + passwordStrength[signUpPasswordScore] | translate }}
          </div>
        </div>
        <div class="lm-modal__reset-field">
          <label class="site__label" for="confirm-new-password">
            {{ 'profile.confirm-new-password' | translate }} <span class="site__field-asterisk">*</span>
          </label>
          <div class="site__field-inner">
            <input
              data-hj-suppress
              type="password"
              class="nice-input"
              required
              id="confirm-new-password"
              formControlName="confirmPassword"
              appTogglePassword
              autocomplete="off"
              tabindex="202"
              [ngClass]="{ error: isResetPasswordSent && resetPasswordForm.controls.confirmPassword.errors }"
            />
          </div>
          <p
            *ngIf="isResetPasswordSent && resetPasswordForm.controls.confirmPassword.errors"
            class="site__form-error site__form-error--tc site__form-main-error"
          >
            <span *ngIf="resetPasswordForm.controls.confirmPassword.errors.required">{{
              'login.enter-password' | translate
            }}</span>
            <span *ngIf="resetPasswordForm.controls.confirmPassword.errors.minlength">{{
              'login.enter-password' | translate
            }}</span>
            <span *ngIf="resetPasswordForm.controls.confirmPassword.errors.mustMatch">{{
              'profile.new-password-match' | translate
            }}</span>
          </p>
        </div>
        <button sparkButton class="auth__btn lm-modal__reset-btn w-full" type="submit">
          <span *ngIf="!isFetching" class="!normal-case">{{ 'profile.update-password' | translate }}</span>
          <app-loading-indicator *ngIf="isFetching" />
        </button>
      </form>
    </ng-container>
    <ng-container *ngIf="isResetPasswordRequestSuccess">
      <p class="lm-modal__text">{{ 'login.reset-password-success' | translate }}</p>
      <button
        data-testid="qa_reset-password-ok-btn"
        sparkButton
        size="large"
        class="w-full mt-[23px]"
        (click)="closeResetPasswordModal(resetPasswordModalId)"
      >
        {{ 'alert.modal-button' | translate }}
      </button>
    </ng-container>
  </div>
</app-modal>
